module.exports = "https://s.pinimg.com/webapp/style/images/HU@2x-8d3281f2.png";